import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from './logger.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { PatientDialogComponent } from 'src/app/components/patient-dialog/patient-dialog.component';
import { tPatientModel } from 'src/app/models/tPatientModel';
import { tModuleModel } from 'src/app/models/tModuleModel';

var TAG = "PatientDialogService";

@Injectable({
    providedIn: 'root'
})
export class PatientDialogService {

    static ACTION_OPEN = "open";
    selectedPatientChange: Subject<tPatientModel> = new Subject<tPatientModel>();
    selectedPatient: tPatientModel;

    constructor(private log: LoggerService,
        private modalService: NgbModal
    ) {


    }

    openDialog() {
        // console.log('open Dialog');
        this.log.d(TAG, 'open Dialog ');
        const modalRef = this.modalService.open(PatientDialogComponent, { size: 'lg', centered: true, backdrop: 'static', keyboard:false });

        // const modalRef = this.modalService.open(ModelComponent, { size: 'lg', backdrop: 'static' });
        // modalRef.componentInstance.action = action;
        // modalRef.componentInstance.status = status;
        // modalRef.componentInstance.tableKeyValue = tableKeyValue;
        // modalRef.componentInstance.msg = msg;

        // modalRef.componentInstance.displayMsg = this.getDisplayMsg(tableKeyValue);
        // modalRef.componentInstance.data = data;


        return modalRef;

    }





}
